export enum ValidationType {
  /** Validazione completa */
  COMPLETE = 'complete',
  /** Validazione parziale */
  PARTIAL = 'partial',
  /** Validazione parziale per il salvataggio in bozza */
  DRAFT = 'draft',
  /** Validazione in collaudo senza validazione
   * (funziona come quello in bozza ma mantenedo esito)
   */
  TESTING = 'testing',
}

// Stringhe costanti per il contesto di validazione
export const VALIDATION_TYPE = '__validationType';
export const CURRENT_SECTION_STEP = '__currentValidationStep';
export const CURRENT_PAGE_STEP = '__currentPageStep';

export function isDraftValidation(context: any): boolean {
  return context?.[VALIDATION_TYPE] === ValidationType.DRAFT;
}
